import { render, staticRenderFns } from "./ExpandableCard.vue?vue&type=template&id=fb300eba&scoped=true&"
import script from "./ExpandableCard.vue?vue&type=script&lang=js&"
export * from "./ExpandableCard.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableCard.vue?vue&type=style&index=0&id=fb300eba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb300eba",
  null
  
)

export default component.exports